import { ColorProps } from 'types';

// ==============================|| DEFAULT THEME COLORS ||============================== //

const defaultColor: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary: ntab blue #0d51a1 (logo); steps are tints/shades of it
  primaryLightest: '#f5f8fb',
  primaryLight: '#e7eef6',
  primary200: '#a3bddb',
  primaryMain: '#0d51a1',
  primaryDark: '#0a3f7e',
  primary800: '#06274d',

  // secondary: ntab orange #f8711a (logo), the highlight colour
  secondaryLight: '#fef1e8',
  secondary200: '#fcbf98',
  secondaryMain: '#f8711a',
  secondaryDark: '#b35113',
  secondary800: '#77360c',

  // success
  successLight: '#b9f6ca',
  success200: '#69f0ae',
  successMain: '#00e676',
  successDark: '#00c853',

  // error
  errorLight: '#ef9a9a',
  errorMain: '#f44336',
  errorDark: '#c62828',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fff8e1',
  warningMain: '#ffe57f',
  warningDark: '#ffc107',

  // grey
  grey50: '#f8fafc',
  grey100: '#eef2f6',
  grey200: '#e3e8ef',
  grey300: '#cdd5df',
  grey500: '#697586',
  grey600: '#4b5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#111936',
  darkBackground: '#1a223f',

  // dark 800 & 900
  darkLevel1: '#29314f',
  darkLevel2: '#212946',

  // text variants
  darkTextTitle: '#d7dcec',
  darkTextPrimary: '#bdc8f0',
  darkTextSecondary: '#8492c4',

  // primary dark
  darkPrimaryLight: '#e2eaf4',
  darkPrimaryMain: '#6490c3',
  darkPrimaryDark: '#3d74b4',
  darkPrimary200: '#9eb9d9',
  darkPrimary800: '#0d51a1',

  // secondary dark
  darkSecondaryLight: '#feeadd',
  darkSecondaryMain: '#f8711a',
  darkSecondaryDark: '#da6317',
  darkSecondary200: '#fcb88c',
  darkSecondary800: '#ae4f12'
};

export default defaultColor;
